export default __webpack_public_path__ + "static/media/laundry2-after-1024w.3931ce36.png";